__turbopack_context__.v({
  "className": "caveat_e0ae93d-module__BwxSTG__className",
});
